// Quickchat AI's app on the ChatGPT Marketplace. Shared by the connect sheet and
// the logged-out entry pages, so the marketplace id lives in one place.
export const CHATGPT_APP_URL =
  'https://chatgpt.com/plugins/plugin_asdk_app_6a4656c688748191be4c5247fb0d5dfc';
